import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { Container, UncontrolledDropdown, DropdownToggle, DropdownMenu, DropdownItem } from "reactstrap";
import { ThreeDots } from 'react-bootstrap-icons';
import { useGetAgentsQuery } from "../../../features/CallApi";
import LoadScreen from "../../UI/LoadScreen";
import { AgentsAdd } from "./AgentsAdd";

export const Agents = () => {
    const navigate = useNavigate();
    const { isLoading, data, refetch, error } = useGetAgentsQuery();
    useEffect(() => {
        refetch()
    }, [])

    return (
        <Container fluid>
            <h3>Агент</h3>
            {error ?
                <div></div>
                :
                <div>
                    {isLoading ?
                        <LoadScreen />
                        :
                        <div >
                            <AgentsAdd refetch={refetch} />
                            <div className="table-responsive">
                                <table className="w-100 table table-hover">
                                    <thead>
                                        <tr>
                                            <th className="pe-3 ps-3">Id</th>
                                            <th>Наименование операции</th>
                                            <th>Телефон</th>
                                            <th>Юр.лицо</th>
                                            <th>Юр.адрес</th>
                                            <th>ИНН</th>
                                            <th></th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {data && data.length > 0 ?
                                            data.map(agent =>
                                                <tr key={agent.id}>
                                                    <td className="pe-3 ps-3">{agent.id}</td>
                                                    <td className="">{agent.operation}</td>
                                                    <td className="">{agent.phones}</td>
                                                    <td className="">{agent.name}</td>
                                                    <td className="">{agent.addres}</td>
                                                    <td className="">{agent.tin}</td>
                                                    <td>
                                                        <UncontrolledDropdown>
                                                            <DropdownToggle color="light" >
                                                                <ThreeDots className='' size='14' />
                                                            </DropdownToggle>
                                                            <DropdownMenu container="body">
                                                                <DropdownItem onClick={() => navigate('edit/' + agent.id)}>Изменить</DropdownItem>
                                                            </DropdownMenu>
                                                        </UncontrolledDropdown>
                                                    </td>
                                                </tr>
                                            ) :
                                            <tr>
                                                <td colSpan={7} className={"text-center"}>Список пуст</td>
                                            </tr>
                                        }
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    }
                </div>
            }
        </Container>
    )
}